import { Box } from '@mui/material';

export const ActivitySearchTab = () => {
  return (
    <Box data-testid="activity-search-tab">
      <h1>Activity Search Tab Content</h1>;
    </Box>
  );
};
